<script type="text/javascript">
  require('./css/main.css');
  require('bootstrap');
  require('bootstrap/dist/css/bootstrap.css');
  import ContactContainer from "./views/ContactContainer.vue"

  export default {
    name: "app",
    components:{
      ContactContainer
    },
    data: () => {
      return {
        showYesOrNo: false,
        showMultiChoice: false,
        isMobile: false
      }
    },
    mounted: function(){
      this.updateSections();
      this.isMobile = (window.innerWidth <= 768);
      document.title = 'TossedCoin.com - Random decisions'
      window.onscroll = this.handleBG;
      this.handleBG();
    },
    methods: {
      updateSections: function() {
        if(this.$route.path == '/YesOrNo'){
          this.showYesOrNo = true;
          this.showMultiChoice = false;
        }
        else if(this.$route.path == '/MultiChoice'){
          this.showYesOrNo = false;
          this.showMultiChoice = true;
        }
        else{
          this.showYesOrNo = false;
          this.showMultiChoice = false;
        }
      },
      openYesOrNo: function(){
        if(this.$route.path != '/YesOrNo'){
          this.$router.push({path: '/YesOrNo'});
        }
      },
      openMultiChoice: function(){
        if(this.$route.path != '/MultiChoice'){
          this.$router.push({path: '/MultiChoice'});
        }
      },
      handleBG: function(){
        if(this.isMobile){
          var position = window.scrollY;
          var window_height = Math.max(document.body.clientHeight);
          console.log(window_height / 3)
          if(position < (window_height - 200) / 3)
            document.body.style.backgroundColor = "#ec5a4b"
          else if(position + 300 < window_height*2 / 3)
            document.body.style.backgroundColor = "#3E3E3E"
          else
            document.body.style.backgroundColor = "#f3f3f3"
        }
      }
    },
    watch:{
      $route: function() {
        this.updateSections();
      }
    },
    metaInfo:{
      title: 'Toto'
    }
  }
</script>

<template>
  
  <div id="app">
    <div class="container">
      <header class="d-flex">
        <router-link to="/"><img id="logo" src="./assets/images/logo.png"/></router-link>
      </header>
      <section>
        <div id="section_logos" class="d-none d-sm-flex" v-if='!isMobile'>
          <transition name="logo">
            <div class="section_logo" v-show="!showYesOrNo">
              <router-link to="/YesOrNo"><img src="./assets/images/yes-or-no-logo.png"/></router-link>
            </div>
          </transition>
          <transition name="logo">
            <div class="section_logo" v-show="!showMultiChoice">
              <router-link to="/MultiChoice"><img src="./assets/images/random-logo.png"/></router-link>
            </div>
          </transition>
          <div class="section_logo">
            <router-link to="/"><img src="./assets/images/about-logo.png"/></router-link>
          </div>
        </div>
        <div id="main_container">
          <transition name="fade"><router-view name="YesOrNo" v-show="!showMultiChoice || isMobile" id="YesOrNo" @click.native="openYesOrNo"/></transition>
          <transition name="fade"><router-view name="MultiChoice" v-show="!showYesOrNo || isMobile" id="MultiChoice" @click.native="openMultiChoice" :class="showMultiChoice ? 'active':''"/></transition>
          <transition name="fade" mode="out-in"><ContactContainer name="Contact" v-show="(!showMultiChoice && !showYesOrNo) || isMobile"></ContactContainer></transition>
        </div>
      </section>
    </div>
  </div>
</template>

<style scoped>
  @media screen and (min-width: 768px){
    .fade-enter-to, .fade-leave{
      flex-grow: 1;
      flex-basis: 33%;
    }

    .fade-enter, .fade-leave-to{
      flex-grow: 0.00001 !important;
      flex-basis: 0 !important;
    }

    body{
      background-color: #ec5a4b;
    }
  }

  .logo-enter-to, .logo-leave{
    transition: opacity 1s;
  }

  .logo-enter, .logo-leave-to{
    opacity: 0;
  }
</style>